import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import img1_1 from "../assests/rio-mall-img01.jpg";
import img1_2 from "../assests/rio-mall-img02.jpg";
import img1_3 from "../assests/rio-mall-img03.jpg";

import img2_1 from "../assests/vallabh-nagar1-img01.jpg";
import img2_2 from "../assests/vallabh-nagar1-img02.jpg";
import img2_3 from "../assests/vallabh-nagar1-img03.jpg";

import img3_1 from "../assests/vallabh-nagar2-img01.jpg";
import img3_2 from "../assests/vallabh-nagar2-img02.jpg";
import img3_3 from "../assests/vallabh-nagar2-img03.jpg";
import img3_4 from "../assests/vallabh-nagar2-img04.jpg";
import img3_5 from "../assests/vallabh-nagar2-img05.jpg";
import img3_6 from "../assests/vallabh-nagar2-img06.jpg";
import img3_7 from "../assests/vallabh-nagar2-img07.jpg";
import img3_8 from "../assests/vallabh-nagar2-img08.jpg";
import img3_9 from "../assests/vallabh-nagar2-img09.jpg";

import img4_1 from "../assests/progressive-point-img01a.jpg";
import img4_2 from "../assests/progressive-point-img02a.jpg";
import img4_3 from "../assests/progressive-point-img03a.jpg";
import img4_4 from "../assests/progressive-point-img03a.jpg";
import img4_5 from "../assests/progressive-point-img04a.jpg";

import img5_1 from "../assests/royal-tower-img01.jpg";
import img5_2 from "../assests/royal-tower-img02.jpg";
import img5_3 from "../assests/royal-tower-img03.jpg";

import img6_1 from "../assests/priyadarshini-nagar-img01.jpg";
import img6_2 from "../assests/priyadarshini-nagar-img02.jpg";

import img7_1 from "../assests/agrasen-chowk-img01a.jpg";
import img7_2 from "../assests/agrasen-chowk-img01b.jpg";

import img8_1 from "../assests/bhatagaon-chowk-img01a.jpg";
import img8_2 from "../assests/bhatagaon-chowk-img01b.jpg";

import img9_1 from "../assests/kamal-vihar-img01a.jpg";
import img9_2 from "../assests/kamal-vihar-img01b.jpg";

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 2,
    slidesToSlide: 1, // optional, default to 1.
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1, // optional, default to 1.
  },
};

const allDetails = [
  {
    id: "tab2_1",
    para: "Fully furnished and customised office with all the frills - just the way you envisioned it. If you need a vibrant workspace, you can always trust Premisin’s space in Rio complex. It offers the complete solution for all office needs making it an ideal workspace on the heart of the city.",
    image: [img1_1, img1_2, img1_3],
    active: "tab-pane fade",
  },
  {
    id: "tab2_2",
    para: "What more can one ask fora working space to be,than an inspiring one at an affordable price. This is what we offer at our co-working spaces in a prime location of Raipur.",
    image: [img2_1, img2_2, img2_3],
    active: "tab-pane fade",
  },
  {
    id: "tab2_3",
    para: "Offers a state-of-the-art coworking space that caters to the needs of professionals and entrepreneurs. This modern workspace provides a collaborative environment for individuals from various industries to work, network, and exchange ideas. Equipped with high-speed internet, comfortable seating, meeting rooms, and amenities like printing and coffee facilities.This modern workspace offers a collaborative and flexible environment for individuals from diverse industries to work, network, and innovate. With stylish and ergonomic furnishings, high-speed internet connectivity, state-of-the-art meeting rooms, and advanced technology infrastructure, the coworking space provides a productive and inspiring atmosphere.",
    image: [
      img3_1,
      img3_2,
      img3_3,
      img3_4,
      img3_5,
      img3_6,
      img3_7,
      img3_8,
      img3_9,
    ],
    active: "tab-pane fade ",
  },
  {
    id: "tab2_4",
    para: "Progressive Point is near to Lalganga Business Park. It is well connected by various modes of transportation and is in close proximity to various civic utilities, & also close to various schools & markets.",
    image: [img4_1, img4_2, img4_3, img4_4, img4_5],
    active: "tab-pane fade",
  },
  {
    id: "tab2_5",
    para: "Royal tower is near to Lalganga Business Park. It is well connected by various modes of transportation and is in close proximity to various civic utilities, & also close to various schools & markets.",
    image: [img5_1, img5_2, img5_3],
    active: "tab-pane fade",
  },
  {
    id: "tab2_6",
    para: "Priyadarshini Nagar in close proximity to several recreational amenities, such as cafes, restaurants, malls, etc. This allows you to take a quick break from your daily work schedule.",
    image: [img6_1, img6_2],
    active: "tab-pane fade",
  },
  {
    id: "tab2_7",
    para: "Premisn is centrally located in Agrasen chowk a prominent locality in the city. The location not only makes it convenient for people from the vicinity to ATM, market, restaurant, bank and medical facility.",
    image: [img7_1, img7_2],
    active: "tab-pane fade",
  },
  {
    id: "tab2_8",
    para: "Premisin is launching a valuable new destination in Bahatagon for the entrepreneurial community. It’s a fully furnished Premium space with private meeting rooms, lounges, and executive cabins, and access to shared amenities.",
    image: [img8_1, img8_2],
    active: "tab-pane fade",
  },
  {
    id: "tab2_9",
    para: "Premisin is launching its 9th center in the heart of the city Kamal Vihar, which will fit within your budget and comfortably accommodate your team. We have taken a modern approach for modern businesses.",
    image: [img9_1, img9_2],
    active: "tab-pane fade show active",
  },
];

const OurLocation = () => {
  return (
    <>
      <section id="locations" className="startup-locations">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-center">
              <h2 className="h1">Our Locations</h2>
              <div className="u-h-4 u-w-50 bg-primary rounded mt-4 mx-auto"></div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 mx-auto mt-5">
              <ul
                className="nav nav-tabs justify-content-center tabs-v2 box-shadow-v2"
                role="tablist"
              >
                <li className="nav-item">
                  <a
                    className="nav-link active"
                    data-toggle="tab"
                    href="#tab2_9"
                    role="tab"
                    aria-expanded="false"
                  >
                    Kamal Vihar
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link "
                    data-toggle="tab"
                    href="#tab2_3"
                    role="tab"
                    aria-expanded="false"
                  >
                    Vallabh Nagar 2.0
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    data-toggle="tab"
                    href="#tab2_2"
                    role="tab"
                    aria-expanded="false"
                  >
                    Vallabh Nagar 1.0
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    data-toggle="tab"
                    href="#tab2_8"
                    role="tab"
                    aria-expanded="false"
                  >
                    Bhatagaon
                  </a>
                </li>

                <li className="nav-item">
                  <a
                    className="nav-link "
                    data-toggle="tab"
                    href="#tab2_1"
                    role="tab"
                    aria-expanded="true"
                  >
                    Rio Mall
                  </a>
                </li>

                <li className="nav-item">
                  <a
                    className="nav-link"
                    data-toggle="tab"
                    href="#tab2_4"
                    role="tab"
                    aria-expanded="false"
                  >
                    Progressive Point
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    data-toggle="tab"
                    href="#tab2_5"
                    role="tab"
                    aria-expanded="false"
                  >
                    Royal Tower
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    data-toggle="tab"
                    href="#tab2_6"
                    role="tab"
                    aria-expanded="false"
                  >
                    Priyadarshini Nagar
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    data-toggle="tab"
                    href="#tab2_7"
                    role="tab"
                    aria-expanded="false"
                  >
                    Agrasen Chowk
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-10 mx-auto mt-5">
              <div className="tab-content tab__slider">
                {allDetails.map((e) => (
                  <div
                    className={e.active}
                    id={e.id}
                    role="tabpanel"
                    key={e.id}
                  >
                    <p className="mb-4 text-center">{e.para}</p>
                    <Carousel
                      swipeable={true}
                      draggable={true}
                      showDots={responsive.mobile ? false : false}
                      responsive={responsive}
                      infinite={true}
                      autoPlay={true}
                      autoPlaySpeed={5000}
                      customTransition="linear 0.8s"
                      containerclassNameName="carousel-container"
                      removeArrowOnDeviceType={["tablet", "mobile"]}
                      dotListclassNameName="custom-dot-list-style"
                      itemclassNameName="carousel-item-padding-200-px"
                    >
                      {e.image.map((p) => (
                        <div class="card p-3">
                          <img
                            className="lazyloadimg3"
                            src={p}
                            data-original="assets/img/rio-mall-img01.jpg"
                            alt="Premisin"
                          />
                        </div>
                      ))}
                    </Carousel>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default OurLocation;
